// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Leetcode Wizard
 * Leetcode Wizard API Description
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TokenDataResponseDto } from './TokenDataResponseDto';
import {
    TokenDataResponseDtoFromJSON,
    TokenDataResponseDtoFromJSONTyped,
    TokenDataResponseDtoToJSON,
} from './TokenDataResponseDto';
import type { UserDataResponseDto } from './UserDataResponseDto';
import {
    UserDataResponseDtoFromJSON,
    UserDataResponseDtoFromJSONTyped,
    UserDataResponseDtoToJSON,
} from './UserDataResponseDto';

/**
 *
 * @export
 * @interface LoginResponseDto
 */
export interface LoginResponseDto {
    /**
     *
     * @type {UserDataResponseDto}
     * @memberof LoginResponseDto
     */
    userData: UserDataResponseDto;
    /**
     *
     * @type {TokenDataResponseDto}
     * @memberof LoginResponseDto
     */
    tokenData: TokenDataResponseDto;
}

/**
 * Check if a given object implements the LoginResponseDto interface.
 */
export function instanceOfLoginResponseDto(value: object): value is LoginResponseDto {
    if (!('userData' in value) || value['userData'] === undefined) return false;
    if (!('tokenData' in value) || value['tokenData'] === undefined) return false;
    return true;
}

export function LoginResponseDtoFromJSON(json: any): LoginResponseDto {
    return LoginResponseDtoFromJSONTyped(json, false);
}

export function LoginResponseDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): LoginResponseDto {
    if (json == null) {
        return json;
    }
    return {
        userData: UserDataResponseDtoFromJSON(json['userData']),
        tokenData: TokenDataResponseDtoFromJSON(json['tokenData']),
    };
}

export function LoginResponseDtoToJSON(value?: LoginResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        userData: UserDataResponseDtoToJSON(value['userData']),
        tokenData: TokenDataResponseDtoToJSON(value['tokenData']),
    };
}
